import type { ProjectMetadataSettings } from "@/shared/types/projectData";

type OnboardingSettingsSource = Pick<
  ProjectMetadataSettings,
  "onboardingTemplate" | "onboardingStatus"
> & {
  onboarding_template?: ProjectMetadataSettings["onboardingTemplate"];
  onboarding_status?: ProjectMetadataSettings["onboardingStatus"];
};

const readString = (value: unknown): string => {
  if (typeof value === "string") {
    return value;
  }
  return "";
};

export const readOnboardingTemplate = (
  settings?: OnboardingSettingsSource | null,
): string =>
  readString(settings?.onboardingTemplate || settings?.onboarding_template);

export const readOnboardingStatus = (
  settings?: OnboardingSettingsSource | null,
): string =>
  readString(settings?.onboardingStatus || settings?.onboarding_status);
